

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useState } from "react";
import { Button, TextField } from "@mui/material";
import { useSetSnackBar } from "../../store/Snackbar.state";

export const DocumentUpload = ({label,documentInfoId,mandatory, control, setValue,getValues,onDelete}) => {
  // const [files, setFiles] = useState([]);  
  const setSnackbar = useSetSnackBar();

  const handleFileUpload = (documentInfoId: number) => (event: any) => {
    const file = event.target.files[0];
    const validExtensions = ['jpg','png',"doc", "docx",'pdf','xlsx'];
    

    
    // Uzantıyı al ve kontrol et
    const extension = file.name.split('.').pop();
    if (!validExtensions.includes(extension)) {
      // Uygun olmayan uzantı, Snackbar'ı ayarla
      setSnackbar({
        severity: "error",
        isOpen: true,
        description: "Geçersiz dosya uzantısı. Sadece jpg, png, doc, pdf ve xlsx türündeki dosyalar kabul edilir."
      });
      return; // Daha fazla işlem yapma
    }

    // Yeni dosya oluştur
    const newFile = { file: file, documentInfoId };
  
    // Mevcut dosyaları al
    const currentFiles = getValues('files');
  
    // Yeni dosyayı mevcut dosyalara ekleyip durumu güncelle
    setValue('files', [...currentFiles, newFile], { shouldValidate: true });
  };
  
  return (
    <form>
      <TextField
      sx={{width:"100%"}}
        type="file"
        id="file"
        // label={label}
        label={
          mandatory ? (
            <span>
              {label} <span style={{ color: 'red' }}>*</span>
            </span>
          ) : (
            label
          )
        }
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        InputProps={{
          multiple: true,
          onChange: handleFileUpload(documentInfoId),
        }}
        // required={mandatory}
      />
    </form>
  );
};
